import { render } from "./CommonField.vue?vue&type=template&id=bcc2ea7e"
import script from "./CommonField.vue?vue&type=script&lang=js"
export * from "./CommonField.vue?vue&type=script&lang=js"

import "./CommonField.vue?vue&type=style&index=0&id=bcc2ea7e&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__